function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var StateHandler = /*#__PURE__*/function () {
  /**
   * @class StateHandler
   * @classdesc For shallowly immutable UI state handling
   */
  function StateHandler() {
    _classCallCheck(this, StateHandler);
    this.stateListeners = [];
    this.state = {};
    this.stashedState = null;
  }

  /**
   * @returns {object} Current state
   */
  return _createClass(StateHandler, [{
    key: "getState",
    value: function getState() {
      return this.state;
    }

    /**
     * @param {Object} state A new state replacing the previous one.
     */
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = state;
      this.notify();
    }

    /**
     * @param {Object} props Extends and overrides keys in state.
     */
  }, {
    key: "updateState",
    value: function updateState(props) {
      this.state = _objectSpread(_objectSpread({}, this.state), props);
      this.notify();
    }

    /**
     * Stashes current state so it can be returned to later on.
     */
  }, {
    key: "stashCurrentState",
    value: function stashCurrentState() {
      if (this.stashedState) {
        // Prevent accidentally overwriting stashed state.
        return;
      }
      this.stashedState = _objectSpread({}, this.state);
    }

    /**
     * To check if we have a state in stash.
     * @return {boolean} True, if we have state in stash.
     */
  }, {
    key: "hasStashedState",
    value: function hasStashedState() {
      return !!this.stashedState;
    }

    /**
     * Retain previously stashed state. Clears the stash.
     */
  }, {
    key: "useStashedState",
    value: function useStashedState() {
      if (this.stashedState) {
        this.setState(this.stashedState);
      }
      this.stashedState = null;
    }

    /**
     * Register a listener function. Listeners will be called every time the state changes.
     * @param {function} consumer The consumer function.
     */
  }, {
    key: "addStateListener",
    value: function addStateListener(consumer) {
      this.stateListeners.push(consumer);
    }

    /**
     * Handles calling registered listeners.
     * @private
     */
  }, {
    key: "notify",
    value: function notify() {
      var _this = this;
      this.stateListeners.forEach(function (consumer) {
        return consumer(_this.getState());
      });
    }
  }]);
}();